// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"ee98cf69","684":"14905561"}[chunkId] + ".chunk.js";
};